module.exports = __webpack_public_path__ + "65bcbc899f379216109acd0b6c494618.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./bower_components/font-awesome/fonts/fontawesome-webfont.svg?v=4.2.0
 ** module id = 23
 ** module chunks = 0
 **/